(function () {
  'use strict';

  var CC = window.ChikuChums || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var noHover = window.matchMedia('(hover: none)').matches;
  // On Data Saver or a slow connection, use Shopify's 480p copies of the films.
  var net = navigator.connection || {};
  var lite = !!net.saveData || /2g|3g/.test(net.effectiveType || '');
  function liteSrc(url) {
    return lite && url ? url.replace('.HD-720p-4.5Mbps-', '.SD-480p-1.5Mbps-') : url;
  }

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var format = CC.moneyFormat || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    function withDelims(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  // Translated text from the theme's language files (see layout/theme.liquid), with [name] placeholders filled in.
  function str(key, values) {
    var s = (CC.strings && CC.strings[key]) || '';
    Object.keys(values || {}).forEach(function (k) { s = s.split('[' + k + ']').join(values[k]); });
    return s;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('cc-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  /* ---------- mobile menu ---------- */
  var menuBtn = document.querySelector('[data-cc-menu-toggle]');
  var mobileNav = document.getElementById('cc-mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      var open = mobileNav.hidden;
      mobileNav.hidden = !open;
      menuBtn.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('cc-drawer');
  var scrim = document.getElementById('cc-scrim');
  var freeShipping = drawer ? Number(drawer.getAttribute('data-free-shipping') || 0) : 0;

  function openDrawer(open) {
    if (!drawer) { if (open) window.location.href = CC.routes.cart; return; }
    if (open) {
      scrim.hidden = false;
      requestAnimationFrame(function () { scrim.classList.add('open'); drawer.classList.add('open'); });
      var closeBtn = drawer.querySelector('[data-cc-close]');
      if (closeBtn) closeBtn.focus();
    } else {
      scrim.classList.remove('open');
      drawer.classList.remove('open');
      setTimeout(function () { scrim.hidden = true; }, 300);
    }
    drawer.setAttribute('aria-hidden', String(!open));
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cc-count]').forEach(function (el) { el.textContent = cart.item_count; });
    if (!drawer) return;
    var lines = drawer.querySelector('[data-cc-lines]');
    var sub = drawer.querySelector('[data-cc-subtotal]');
    var shipText = drawer.querySelector('[data-cc-ship-text]');
    var shipBar = drawer.querySelector('[data-cc-ship-bar]');
    var checkout = drawer.querySelector('[data-cc-checkout]');
    sub.textContent = formatMoney(cart.total_price);
    if (freeShipping > 0) {
      var left = freeShipping - cart.total_price;
      shipText.textContent = left <= 0 ? str('freeShippingReached') : str('freeShippingLeft', { amount: formatMoney(left) });
      shipBar.style.width = Math.min(100, cart.total_price / freeShipping * 100) + '%';
    }
    checkout.disabled = cart.item_count === 0;
    if (cart.item_count === 0) {
      lines.innerHTML = '<p class="empty">' + escapeHtml(str('bagEmpty')) + '</p>';
      return;
    }
    lines.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<small>' + escapeHtml(str('size', { size: item.variant_title })) + '</small>' : '';
      return '<div class="line">' +
        (img ? '<img src="' + escapeHtml(img) + '" alt="" width="72" height="72" loading="lazy">' : '<span></span>') +
        '<div><a href="' + escapeHtml(item.url) + '"><b>' + escapeHtml(item.product_title) + '</b></a>' + variant +
        '<div class="qty"><button type="button" data-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="' + escapeHtml(str('oneLess')) + '">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="' + escapeHtml(str('oneMore')) + '">+</button></div></div>' +
        '<span class="price">' + formatMoney(item.final_line_price) + '</span></div>';
    }).join('');
  }

  function fetchCart() {
    return fetch(CC.routes.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeLine(key, qty) {
    return fetch(CC.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(variantId, qty, label) {
    return fetch(CC.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || str('addError'));
        return data;
      });
    }).then(function () {
      return fetchCart();
    }).then(function (cart) {
      renderCart(cart);
      var b = document.querySelector('.bag-btn');
      if (b) { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); }
      toast(str('added', { item: label || str('item') }));
      openDrawer(true);
    }).catch(function (err) {
      toast(err.message);
    });
  }

  document.querySelectorAll('[data-cc-open-bag]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (!drawer) return;
      e.preventDefault();
      openDrawer(true);
    });
  });
  if (drawer) {
    drawer.querySelector('[data-cc-close]').addEventListener('click', function () { openDrawer(false); });
    scrim.addEventListener('click', function () { openDrawer(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) openDrawer(false); });
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-key]');
      if (b) changeLine(b.getAttribute('data-key'), Number(b.getAttribute('data-qty')));
    });
  }

  /* ---------- product cards: 360° spin + quick add ---------- */
  function playMedia(media, on, restart) {
    var v = media.querySelector('video');
    if (!v) return;
    var btn = media.parentNode.querySelector('[data-cc-spin]');
    function mark(playing) {
      media.classList.toggle('playing', playing);
      if (btn) {
        btn.setAttribute('aria-pressed', String(playing));
        btn.setAttribute('aria-label', str(playing ? 'pause360' : 'play360', { title: btn.getAttribute('data-label') }));
      }
    }
    if (on) {
      if (restart) { try { v.currentTime = 0; } catch (e) {} }
      var p = v.play();
      if (p && p.then) p.then(function () { if (!v.paused) mark(true); }).catch(function () {});
      else mark(true);
    } else {
      v.pause();
      mark(false);
    }
  }

  // The spin starts by itself once the card crosses the middle of the screen (phones and computers),
  // keeps playing at normal speed while it's on screen, and pauses when it scrolls away.
  // A tap on the 360° button pauses it, and it stays paused until tapped again.
  // The videos are silent, so they play even with Reduce Motion on (the owner wants them always moving).
  var autoSpins = [];
  function checkSpins() {
    var vh = window.innerHeight, mid = vh / 2;
    autoSpins.forEach(function (media) {
      var r = media.getBoundingClientRect();
      var v = media.querySelector('video');
      if (v.preload === 'none' && r.top < vh * 1.5 && r.bottom > -vh * 0.5) v.preload = 'auto';
      if (r.bottom <= 0 || r.top >= vh) {
        if (media.ccOn) { media.ccOn = false; playMedia(media, false); }
      } else if (!media.ccOn && !media.ccUserPaused && r.top < mid && r.bottom > mid) {
        media.ccOn = true;
        playMedia(media, true, false);
      }
    });
  }

  document.querySelectorAll('[data-cc-card]').forEach(function (card) {
    var media = card.querySelector('.media');
    if (media && media.querySelector('video')) {
      var wrap = media.parentNode;
      var spinVideo = media.querySelector('video');
      if (lite && spinVideo.getAttribute('data-lite')) spinVideo.src = spinVideo.getAttribute('data-lite');
      var spinBtn = wrap.querySelector('[data-cc-spin]');
      if (spinBtn) {
        spinBtn.addEventListener('click', function () {
          var on = !media.classList.contains('playing');
          media.ccOn = on;
          media.ccUserPaused = !on;
          playMedia(media, on, false);
        });
      }
      autoSpins.push(media);
      if (!noHover) {
        // on computers, hovering a card also starts its spin; leaving stops it unless it's the one playing by scroll
        wrap.addEventListener('mouseenter', function () { if (!media.ccUserPaused) playMedia(media, true, !media.ccOn); });
        wrap.addEventListener('mouseleave', function () { if (!media.ccOn) playMedia(media, false); });
        media.addEventListener('focus', function () { playMedia(media, true, !media.ccOn); });
        media.addEventListener('blur', function (e) { if (e.relatedTarget !== spinBtn && !media.ccOn) playMedia(media, false); });
      }
    }

    var add = card.querySelector('[data-cc-add]');
    var notify = card.querySelector('[data-cc-notify]');
    var notifySize = card.querySelector('[data-cc-notify-size]');
    var price = card.getAttribute('data-price-label') || '';
    var selected = null;
    card.querySelectorAll('.size').forEach(function (b) {
      b.addEventListener('click', function () {
        card.querySelectorAll('.size').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        selected = b;
        var available = b.getAttribute('data-available') === 'true';
        add.disabled = !available;
        add.textContent = available ? str('addToBagPrice', { price: price }) : (card.getAttribute('data-out-label') || str('soldOut'));
        if (notify) {
          notify.hidden = available;
          if (notifySize) notifySize.value = card.getAttribute('data-title') + ', size ' + b.textContent.trim();
        }
      });
    });
    if (add) {
      add.addEventListener('click', function () {
        if (selected) {
          addToCart(selected.getAttribute('data-variant'), 1, card.getAttribute('data-title') + ' (' + selected.textContent.trim() + ')');
        } else if (add.getAttribute('data-variant')) {
          addToCart(add.getAttribute('data-variant'), 1, card.getAttribute('data-title'));
        }
      });
    }
  });

  if (autoSpins.length) {
    window.addEventListener('scroll', checkSpins, { passive: true });
    window.addEventListener('resize', checkSpins);
    checkSpins();
  }

  /* ---------- product page ---------- */
  var productForm = document.querySelector('[data-cc-product-form]');
  if (productForm) {
    var variantsEl = document.getElementById('cc-variants');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var submit = productForm.querySelector('[type="submit"]');
    var priceEl = document.querySelector('[data-cc-price]');
    var pnotify = document.querySelector('[data-cc-product-notify]');
    var pnotifySize = pnotify ? pnotify.querySelector('[data-cc-notify-size]') : null;
    function currentId() {
      var el = productForm.querySelector('input[name="id"]:checked') || productForm.querySelector('input[name="id"][type="hidden"]');
      return el ? el.value : null;
    }
    function selectVariant(id) {
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      submit.disabled = !v.available;
      submit.textContent = v.available ? str('addToBag') : (productForm.getAttribute('data-out-label') || str('soldOut'));
      if (pnotify) {
        pnotify.hidden = v.available;
        if (pnotifySize) pnotifySize.value = productForm.getAttribute('data-title') + ', ' + (productForm.getAttribute('data-option') || 'Size').toLowerCase() + ' ' + v.title;
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    productForm.querySelectorAll('.size-radio').forEach(function (r) {
      r.addEventListener('change', function () { selectVariant(r.value); });
    });
    productForm.addEventListener('submit', function (e) {
      var id = currentId();
      if (!id) return;
      e.preventDefault();
      addToCart(id, 1, productForm.getAttribute('data-title'));
    });
  }

  /* ---------- size guide pop-up ---------- */
  var sizeGuide = document.getElementById('cc-size-guide');
  if (sizeGuide) {
    document.querySelectorAll('[data-cc-size-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (sizeGuide.showModal) sizeGuide.showModal();
        else if (b.getAttribute('data-href')) window.location.href = b.getAttribute('data-href');
      });
    });
    sizeGuide.querySelectorAll('[data-cc-size-close]').forEach(function (b) {
      b.addEventListener('click', function () { sizeGuide.close(); });
    });
    // a click on the dimmed backdrop (outside the panel) closes it too
    sizeGuide.addEventListener('click', function (e) { if (e.target === sizeGuide) sizeGuide.close(); });
  }

  /* ---------- hero: title letters, films, countdown ---------- */
  var title = document.querySelector('[data-cc-split]');
  if (title && !reduce) {
    var textNode = title.firstChild;
    if (textNode && textNode.nodeType === 3) {
      var frag = document.createDocumentFragment();
      Array.prototype.forEach.call(textNode.textContent.trim(), function (c, i) {
        var s = document.createElement('span');
        s.className = 'ch';
        s.setAttribute('aria-hidden', 'true');
        s.textContent = c === ' ' ? ' ' : c;
        s.style.animationDelay = (0.05 * i + 0.1) + 's';
        frag.appendChild(s);
      });
      title.replaceChild(frag, textNode);
    }
  }

  /*
    film(root, opts) plays one film scene by itself as soon as any part of it is on screen, and
    keeps it playing until the visitor presses pause. The page scrolls past it normally.
    Several clips play back to back on a loop: a second, hidden video loads the next clip while
    the current one plays, then the two crossfade. opts:
      sources   – clip URLs, in order
      onClip(i) – called when clip i starts
  */
  var films = [];
  var filmDebug = [];
  function film(root, opts) {
    var a = root.querySelector('video');
    var sources = opts.sources.filter(Boolean).map(liteSrc);
    if (!a || !sources.length) return;
    var bar = root.querySelector('.progress');
    var btn = root.querySelector('[data-cc-film-toggle]');
    var btnLabel = btn && btn.querySelector('[data-cc-film-label]');
    var single = sources.length === 1;
    // iPhones only let a video play by itself when it is muted and inline, and they check the
    // attributes as well as the properties, so set both on every video we play
    function inlineMuted(v) {
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
    }
    if (a.getAttribute('src') !== sources[0]) a.src = sources[0];
    inlineMuted(a);
    a.loop = single;
    var b = null;
    if (!single) {
      b = document.createElement('video');
      inlineMuted(b);
      b.preload = 'auto';
      b.setAttribute('aria-hidden', 'true');
      b.className = 'next';
      a.insertAdjacentElement('afterend', b);
    }
    var cur = a, nxt = b, index = 0;
    // started: it has been on screen once, so it keeps playing after it scrolls away
    var visible = false, started = false, near = false, playing = false;
    var userPaused = false;

    function mark(on) {
      var was = playing;
      playing = on;
      if (on && !was) requestAnimationFrame(tick);
      root.classList.toggle('playing', on);
      if (btn) {
        btn.setAttribute('aria-pressed', String(on));
        btn.setAttribute('aria-label', str(on ? 'pauseFilm' : 'playFilm'));
        if (btnLabel) btnLabel.textContent = str(on ? 'pause' : 'play');
      }
    }
    function shouldPlay() {
      // On phones a film rests while it's fully off screen (they can only decode a few videos at
      // once) and carries on when it's back in view; on computers it keeps playing.
      return !userPaused && !document.hidden && (visible || (started && !noHover));
    }
    var lastError = '';
    function play() {
      var p = cur.play();
      if (p && p.then) {
        p.then(function () {
          lastError = '';
          root.classList.remove('film-blocked');
          if (!cur.paused) mark(true);
        }).catch(function (e) {
          lastError = (e && (e.name + ': ' + e.message)) || 'play failed';
          // the phone refused to start it by itself: offer a big play button, which always works
          if (e && e.name === 'NotAllowedError') root.classList.add('film-blocked');
          mark(false);
        });
      } else mark(true);
    }
    // a big "Play film" button over the film, shown only if the phone won't start it by itself
    var tap = document.createElement('button');
    tap.type = 'button';
    tap.className = 'film-tap';
    tap.innerHTML = '<span class="spin-ico" aria-hidden="true"></span>' + escapeHtml(str('playFilm'));
    (a.parentNode).appendChild(tap);
    tap.addEventListener('click', function () {
      userPaused = false;
      started = true;
      root.classList.remove('film-blocked');
      play();
    });
    // watchdog: if it should be playing but isn't moving, try again every couple of seconds
    var lastT = -1;
    setInterval(function () {
      if (!shouldPlay()) { lastT = -1; return; }
      if (cur.paused || cur.currentTime === lastT) {
        if (!cur.getAttribute('src')) cur.src = sources[index];
        play();
      }
      lastT = cur.currentTime;
    }, 2000);
    function update() {
      if (visible) started = true;
      if (shouldPlay()) { if (cur.paused) play(); }
      else if (!cur.paused || playing) { cur.pause(); mark(false); }
    }
    // try again as soon as the clip can play (an early play() can fail while it's still loading)
    a.addEventListener('canplay', function () { if (a === cur) update(); });
    if (b) b.addEventListener('canplay', function () { if (b === cur) update(); });
    function loadNext() {
      if (!nxt) return;
      var n = sources[(index + 1) % sources.length];
      if (nxt.getAttribute('src') !== n) nxt.src = n;
    }

    function advance() {
      index = (index + 1) % sources.length;
      var prev = cur;
      cur = nxt;
      nxt = prev;
      // phones don't always buffer the hidden video ahead, so make sure it has the right clip
      if (cur.getAttribute('src') !== sources[index]) cur.src = sources[index];
      try { cur.currentTime = 0; } catch (e) {}
      cur.classList.remove('next');
      prev.classList.add('next');
      if (opts.onClip) opts.onClip(index);
      if (shouldPlay()) play(); else mark(false);
      // load the following clip into the hidden video once the crossfade is done
      setTimeout(function () { if (cur.readyState >= 4) loadNext(); }, 700);
    }
    if (!single) {
      [a, b].forEach(function (v) {
        // fetch the next clip only once this one has buffered, so they don't compete for bandwidth
        v.addEventListener('canplaythrough', function () { if (v === cur) loadNext(); });
        v.addEventListener('ended', function () { if (v === cur) advance(); });
        // if a clip can't load, move on to the next one instead of stopping
        v.addEventListener('error', function () { if (v === cur && v.getAttribute('src')) setTimeout(advance, 400); });
      });
    }

    function drawBar() {
      if (!bar || !cur.duration) return;
      var p = single ? cur.currentTime / cur.duration : (index + cur.currentTime / cur.duration) / sources.length;
      bar.style.width = (Math.min(1, p) * 100).toFixed(2) + '%';
    }
    function tick() {
      drawBar();
      if (playing) requestAnimationFrame(tick);
    }
    // timeupdate keeps the bar moving even where animation frames are throttled
    a.addEventListener('timeupdate', function () { if (a === cur) drawBar(); });
    if (b) b.addEventListener('timeupdate', function () { if (b === cur) drawBar(); });

    if (btn) {
      btn.addEventListener('click', function () {
        userPaused = playing;
        if (userPaused) { cur.pause(); mark(false); } else play();
      });
    }

    function check() {
      var r = root.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
      // start buffering about three screens ahead
      if (!near && r.top < vh * 3 && r.bottom > -vh) {
        near = true;
        // no load() here: on iPhones it can cancel a play() that's already starting
        if (a.preload !== 'auto') a.preload = 'auto';
        if (a.readyState >= 4) loadNext();
      }
      // starts as soon as any part of it is on screen
      if (r.top < vh && r.bottom > 0) visible = true;
      else visible = false;
      update();
    }
    films.push(check);

    // ?ccdebug=1 in the address shows what the browser reports for each film (for testing on phones)
    if (/[?&]ccdebug=1/.test(location.search)) {
      var log = [];
      [a, b].forEach(function (v, n) {
        if (!v) return;
        ['loadstart', 'loadedmetadata', 'canplay', 'canplaythrough', 'playing', 'pause', 'waiting', 'stalled', 'suspend', 'ended', 'error', 'abort', 'emptied'].forEach(function (type) {
          v.addEventListener(type, function () {
            log.push((n ? 'B' : 'A') + ':' + type + (type === 'error' && v.error ? '(' + v.error.code + ')' : ''));
            if (log.length > 8) log.shift();
          });
        });
      });
      filmDebug.push(function () {
        var v = cur;
        return (root.hasAttribute('data-cc-hero') ? 'HERO' : 'FARM') +
          ' clip ' + (index + 1) + '/' + sources.length +
          ' | visible=' + visible + ' started=' + started + ' userPaused=' + userPaused + ' playing=' + playing +
          '\nvideo ' + (v === a ? 'A' : 'B') + ': paused=' + v.paused + ' t=' + v.currentTime.toFixed(1) +
          ' ready=' + v.readyState + ' net=' + v.networkState + ' err=' + (v.error ? v.error.code : '-') +
          '\nsrc=' + (v.getAttribute('src') || '(none)').split('/').pop().slice(0, 24) +
          '\nlast play error: ' + (lastError || '-') +
          '\nevents: ' + log.join(' ');
      });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[entries.length - 1].isIntersecting;
        update();
      }).observe(root);
    }
  }

  var hero = document.querySelector('[data-cc-hero]');
  if (hero) {
    var heroVideo = hero.querySelector('video');
    film(hero, { sources: heroVideo ? [heroVideo.getAttribute('src')] : [] });
  }

  // "From farm to first outfit": the clips play back to back, with a caption per clip
  document.querySelectorAll('[data-cc-journey]').forEach(function (journey) {
    var srcs = [];
    try { srcs = JSON.parse(journey.getAttribute('data-cc-sources') || '[]'); } catch (e) {}
    var steps = journey.querySelectorAll('[data-cc-step]');
    var dots = journey.querySelectorAll('[data-cc-dot]');
    film(journey, {
      sources: srcs,
      onClip: function (i) {
        steps.forEach(function (s, k) { s.classList.toggle('on', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('on', k <= i); });
      }
    });
  });

  if (films.length) {
    var checkFilms = function () { films.forEach(function (f) { f(); }); };
    window.addEventListener('scroll', checkFilms, { passive: true });
    window.addEventListener('resize', checkFilms);
    window.addEventListener('load', checkFilms);
    window.addEventListener('pageshow', checkFilms);
    document.addEventListener('visibilitychange', checkFilms);
    // Some phones (for example iPhones in Low Power Mode) only allow video to start after a touch,
    // so the first tap or touch anywhere on the page starts any film that should be playing.
    ['touchstart', 'touchend', 'click', 'keydown'].forEach(function (type) {
      document.addEventListener(type, checkFilms, { passive: true, capture: true });
    });
    checkFilms();
  }

  if (filmDebug.length) {
    var panel = document.createElement('pre');
    panel.className = 'film-debug';
    document.body.appendChild(panel);
    setInterval(function () {
      panel.textContent = navigator.userAgent.replace(/^Mozilla\/5\.0 /, '').slice(0, 90) +
        '\nlow data: ' + (!!(navigator.connection && navigator.connection.saveData)) + '  reduce motion: ' + reduce +
        '\n\n' + filmDebug.map(function (f) { return f(); }).join('\n\n');
    }, 500);
  }

  document.querySelectorAll('[data-cc-countdown]').forEach(function (cd) {
    var at = new Date(cd.getAttribute('data-cc-countdown')).getTime();
    if (isNaN(at) || at <= Date.now()) { cd.hidden = true; return; }
    var pad = function (n) { return String(n).padStart(2, '0'); };
    function tick() {
      var s = Math.max(0, Math.floor((at - Date.now()) / 1000));
      var d = Math.floor(s / 86400); s %= 86400;
      var h = Math.floor(s / 3600); s %= 3600;
      var m = Math.floor(s / 60); s %= 60;
      cd.querySelector('[data-d]').textContent = pad(d);
      cd.querySelector('[data-h]').textContent = pad(h);
      cd.querySelector('[data-m]').textContent = pad(m);
      cd.querySelector('[data-s]').textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- films that play while on screen ---------- */
  // Plays once about a third of the video is on screen, up/down or sideways in a swipe gallery,
  // and pauses when it leaves. Measured on every scroll (page or gallery) so it never depends on
  // the browser reporting visibility by itself.
  var autoVideos = [].slice.call(document.querySelectorAll('[data-cc-autoplay]'));
  function checkAutoVideos() {
    var vw = window.innerWidth, vh = window.innerHeight;
    autoVideos.forEach(function (v) {
      var r = v.getBoundingClientRect();
      var w = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0));
      var h = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      var seen = r.width && r.height ? (w * h) / (r.width * r.height) >= 0.35 : false;
      // a swipe gallery hides slides that are scrolled out of its own box
      var box = v.closest('.gallery');
      if (seen && box) {
        var b = box.getBoundingClientRect();
        seen = r.left < b.right - r.width * 0.35 && r.right > b.left + r.width * 0.35;
      }
      if (seen === v.ccVisible) return;
      v.ccVisible = seen;
      if (seen) { if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }
  if (autoVideos.length) {
    // scroll events from a gallery don't bubble, so listen in the capture phase to hear them too
    document.addEventListener('scroll', checkAutoVideos, { passive: true, capture: true });
    window.addEventListener('resize', checkAutoVideos);
    window.addEventListener('load', checkAutoVideos);
    autoVideos.forEach(function (v) { v.addEventListener('canplay', function () { if (v.ccVisible && v.paused) v.play().catch(function () {}); }); });
    checkAutoVideos();
  }

  /* ---------- unlock videos with a tap ----------
     iPhones in Low Power Mode (and some Android battery savers) won't let any website start a video
     by itself until the visitor touches the page. On a tap we start every not-yet-unlocked video
     within a few screens, inside the tap, which unlocks it for good, then pause the ones that
     shouldn't be playing yet. From then on the normal scroll rules start and stop them. */
  function unlockVideos() {
    var vh = window.innerHeight;
    document.querySelectorAll('video').forEach(function (v) {
      if (v.ccUnlocked || !v.paused) return;
      var r = v.getBoundingClientRect();
      if (r.top > vh * 3 || r.bottom < -vh * 2) return;
      v.muted = true;
      var p = v.play();
      if (p && p.then) {
        p.then(function () {
          v.ccUnlocked = true;
          var media = v.closest('.media');
          var inFilm = v.closest('[data-cc-hero], [data-cc-journey]');
          // a film's current clip is left to the film; its hidden next clip waits its turn
          if (inFilm ? v.classList.contains('next') : !v.ccVisible && !(media && media.ccOn)) v.pause();
          // let the films and spins decide which ones should be playing now
          films.forEach(function (f) { f(); });
          checkSpins();
        }).catch(function () {});
      }
    });
  }
  ['touchend', 'click', 'keydown'].forEach(function (type) {
    document.addEventListener(type, unlockVideos, { passive: true, capture: true });
  });
})();
